<template>
  <div>
    <div class="list-cells">
      <div class="list-cell">
        <div class="list-cell__main" @click="open(1)">
          <div class="list-cell__index"><span>{{ 1 }}</span></div>
          <div class="list-cell__content">
            <p>可流动资产</p>
          </div>
          <div class="list-cell__toggle">
            <span v-if="opened == 1"><i class="iconfont icon-shang"></i></span>
            <span v-else><i class="iconfont icon-xia"></i></span>
          </div>
        </div>
        <div class="list-content" v-if="opened === 1">
          <div class="list-content-item">
            <div class="list-content-item__title">银行存款</div>
            <div class="list-content-item__value">{{ numberFormat(result.bankAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-calc plus">+</div>
          <div class="list-content-item">
            <div class="list-content-item__title">库存金额</div>
            <div class="list-content-item__value">{{ numberFormat(result.stockAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-calc plus">+</div>
          <div class="list-content-item">
            <div class="list-content-item__title">应收金额</div>
            <div class="list-content-item__value">{{ numberFormat(result.recAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-calc minus">-</div>
          <div class="list-content-item">
            <div class="list-content-item__title">应付金额</div>
            <div class="list-content-item__value">{{ numberFormat(result.payAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-calc plus">+</div>
          <div class="list-content-item">
            <div class="list-content-item__title">可融资额</div>
            <div class="list-content-item__value">{{ numberFormat(result.financingAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-calc equal">=</div>
          <div class="list-content-item">
            <div class="list-content-item__title">可流动资产</div>
            <div class="list-content-item__value">{{ numberFormat(result.amount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-item">
            <div class="list-content-item__title">资金占用</div>
            <div class="list-content-item__value">{{ numberFormat(result.occupyingAmount, '#,##0.##') }}元</div>
          </div>
        </div>
      </div>

      <div class="list-cell">
        <div class="list-cell__main" @click="open(2)">
          <div class="list-cell__index"><span>{{ 2 }}</span></div>
          <div class="list-cell__content">
            <p>资金周转天数</p>
          </div>
          <div class="list-cell__toggle">
            <span v-if="opened == 2"><i class="iconfont icon-shang"></i></span>
            <span v-else><i class="iconfont icon-xia"></i></span>
          </div>
        </div>
        <div class="list-content" v-if="opened === 2">
          <div class="list-content-item">
            <div class="list-content-item__title">平均库存天数</div>
            <div class="list-content-item__value">{{ result.stockDay }}</div>
          </div>
          <div class="list-content-calc plus">+</div>
          <div class="list-content-item">
            <div class="list-content-item__title">平均应收天数</div>
            <div class="list-content-item__value">{{ result.recDay }}</div>
          </div>
          <div class="list-content-calc minus">-</div>
          <div class="list-content-item">
            <div class="list-content-item__title">平均应付天数</div>
            <div class="list-content-item__value">{{ result.payDay }}</div>
          </div>
          <div class="list-content-calc equal">=</div>
          <div class="list-content-item">
            <div class="list-content-item__title">资金占用天数</div>
            <div class="list-content-item__value">{{ result.day }}</div>
          </div>
          <div class="list-content-item">
            <div class="list-content-item__title">平均每天资金占用</div>
            <div class="list-content-item__value">{{ numberFormat(result.dayAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-item">
            <div class="list-content-item__title">资金周转次数</div>
            <div class="list-content-item__value">{{ result.turnover }}</div>
          </div>
        </div>
      </div>

      <div class="list-cell">
        <div class="list-cell__main" @click="open(3)">
          <div class="list-cell__index"><span>{{ 3 }}</span></div>
          <div class="list-cell__content">
            <p>授信额度</p>
          </div>
          <div class="list-cell__toggle">
            <span v-if="opened == 3"><i class="iconfont icon-shang"></i></span>
            <span v-else><i class="iconfont icon-xia"></i></span>
          </div>
        </div>
        <div class="list-content" v-if="opened === 3">
          <div class="list-content-item">
            <div class="list-content-item__title">可授信额度</div>
            <div class="list-content-item__value">{{ numberFormat(result.creditAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-calc minus">-</div>
          <div class="list-content-item">
            <div class="list-content-item__title">资金占用</div>
            <div class="list-content-item__value">{{ numberFormat(result.occupyingAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-calc minus">x</div>
          <div class="list-content-item">
            <div class="list-content-item__title">授信比例</div>
            <div class="list-content-item__value">{{ result.creditRate }}</div>
          </div>
          <div class="list-content-calc equal">=</div>
          <div class="list-content-item">
            <div class="list-content-item__title">剩余授信额度</div>
            <div class="list-content-item__value">{{ numberFormat(result.remainAmount, '#,##0.##') }}元</div>
          </div>
          <div class="list-content-item">
            <div class="list-content-item__title">已授信额度</div>
            <div class="list-content-item__value">{{ numberFormat(result.usedAmount, '#,##0.##') }}元</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      result: {},
      opened: 3
    }
  },
  mounted() {
    this.getCreditAmount()
  },
  methods: {
    getCreditAmount() {
      let me = this

      me.$ajax({
        url: "/api/finance/credit/amount"
      }).then(function (res) {
        if (res.success) {
          me.result = res.data
        }
      });
    },
    open(index) {
      this.opened = index == this.opened ? -1 : index
    }
  }
}
</script>

<style scoped>
.list-cells {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
  padding: 10px 0;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #8b8b8b;

  display: flex;
  justify-content: space-between;
  
  white-space:nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  padding: 0 20px;
}

.list-content {
  padding: 10px 0;
  background-color: var(--weui-BG-1);
}
.list-content-item {
  width: 90%;
  height: 36px;
  line-height: 36px;
  margin: 10px auto;
  border-radius: 5px;
  overflow: hidden;
  font-size: large;
  font-weight: bold;
  text-align: center;
  display: flex;
  position: relative;
  z-index: 10;
}
.list-content-item__title {
  flex: 1;
  color: #517ea9;
  background-color: #edfbff;
}
.list-content-item__value {
  flex: 1;
  color: #35baf6;
  background-color: #ecedf0;
}
.list-content-calc {
  width: 32px;
  height: 32px;
  margin: -20px auto;
  line-height: 32px;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  border-radius: 50%;
  color: white;
  background-color: aquamarine;
  position: relative;
  z-index: 11;
}
.plus {
  background-color: #35baf6;
}
.minus {
  background-color: #e44959;
}
.equal {
  background-color: #e6a23c;
}
</style>